import React from 'react';
import { trackClick } from 'js/utils/trackClick';
import routes from 'sitewide-js/core_pre_webpack/routes';

import { CommonButton } from './common';
import { ImpressionWatcher } from 'js/utils/impressions';
import styled from 'astroturf/react';
import _NoWrapSpan from "index-NoWrapSpan.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/churned_user_reactivation/index.tsx?styleId=NoWrapSpan";
import _ButtonWrapper from "index-ButtonWrapper.module.scss!=!astroturf/inline-loader?style=1!/var/lib/jenkins-code/academia-app/app/assets/javascripts/header/FocusedNav/churned_user_reactivation/index.tsx?styleId=ButtonWrapper";


type Props = {
  offer: 'price' | 'discount';
  value: string;
  mentions?: number;
};

const TRIGGER = 'reactivate_button';

const NoWrapSpan = /*#__PURE__*/styled("span", null, {
  displayName: "NoWrapSpan",
  styles: _NoWrapSpan
});

const ButtonWrapper = /*#__PURE__*/styled("div", null, {
  displayName: "ButtonWrapper",
  styles: _ButtonWrapper
});

export default function ChurnedUserReactivationButton({ offer, value }: Props) {
  const clickThrough = () => {
    trackClick({
      source: 'churned_user_reactivation_button',
      extra: {},
    });
    window.location.href = routes.checkout_path({
      feature: 'churned_user_reactivation',
      trigger: TRIGGER,
      from_navbar: true,
    });
  };

  const buttonContent =
    offer === 'discount' ? (
      <>
        Reactivate Premium, <NoWrapSpan>{value} OFF</NoWrapSpan>
      </>
    ) : (
      <>
        Reactivate Premium <NoWrapSpan>for {value}</NoWrapSpan>
      </>
    );

  return (
    <ButtonWrapper>
      <ImpressionWatcher source={TRIGGER} extra={{ offer: offer }}>
        <CommonButton
          buttonContent={buttonContent}
          clickThrough={clickThrough}
        />
      </ImpressionWatcher>
    </ButtonWrapper>
  );
}
